var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:(_vm.darkModeText + " " + _vm.customClass + " " + (!_vm.noMargin ? 'ml-1 mb-2' : ''))},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }